import { render, staticRenderFns } from "./unitMember.vue?vue&type=template&id=70ba7988&scoped=true&"
import script from "./unitMember.vue?vue&type=script&lang=js&"
export * from "./unitMember.vue?vue&type=script&lang=js&"
import style0 from "./unitMember.vue?vue&type=style&index=0&id=70ba7988&lang=scss&scoped=true&"
import style1 from "./unitMember.vue?vue&type=style&index=1&id=70ba7988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ba7988",
  null
  
)

export default component.exports